import styled from 'styled-components';
import { Select, Card } from '@minerva-analytics/pantheon';
import { ORANGE } from 'root/theme';


const ShareLandingContainer = styled.div`
`;

const QuizSelect = styled(Select)`
  display: inline-block;
  margin-right: 1rem;
  width: calc(100% - 70px - 1rem);
`;

const ShareLandingTitle = styled.h2`
  font-size: 1.75rem;
  text-align: center;
`;

const ShareLandingSubtitle = styled.h3`
  font-size: 1.1rem;
  text-align: center;
  margin-bottom: 2rem;
`;

const UserName = styled.span`
  color: ${ORANGE};
`;

const InfoCard = styled(Card).attrs({
  size: `small`,
})`
  margin: 5rem 0 0 0;
  border-radius: 20px;
`;

export {
  ShareLandingContainer,
  QuizSelect,
  ShareLandingTitle,
  ShareLandingSubtitle,
  UserName,
  InfoCard,
};
